import { useState, useEffect } from "react";
import "./TemplateList.2.0.css";
import {useLocation} from "react-router-dom";
import PropTypes from "prop-types";

function TemplateList2({ apiBaseUrl }) {
    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);  // ✅ Track overall loading state
    const [loadingTemplateId, setLoadingTemplateId] = useState(null); // ✅ Track which template is loading
    const [fetchError, setFetchError] = useState(null);
    const search = useLocation().search;
    const ids = new URLSearchParams(search).get('ids');
    const token = new URLSearchParams(search).get('token');
    const locale = new URLSearchParams(search).get('locale');
    const documentType = new URLSearchParams(search).get('documentType');

    const templatesUrl = `${apiBaseUrl}/api/allTemplates?token=${token}&documentType=${documentType}`;
    const pdfUrl = `${apiBaseUrl}/api/getPdf?token=${token}`;

    console.log("ids", ids);
    console.log("token", token);
    console.log("locale", locale);
    //const isAdmin = new URLSearchParams(search).get('isAdmin');

    useEffect(() => {
        setLoadingTemplates(true);
        fetch(templatesUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch templates");
                }
                return response.json();
            })
            .then((data) => {
                setTemplates(data.templates || []);
                setLoadingTemplates(false);
            })
            .catch((error) => {
                console.error("Error fetching templates:");
                setFetchError(error.message);
                setLoadingTemplates(false);
            });
    }, [apiBaseUrl]);

    async function handleTemplateClick(template) {
        const idTemplate = template.template_id;
        console.log("Clicked Template:", idTemplate);
        setLoadingTemplateId(idTemplate); // ✅ Show loader on the clicked template

        try {
            console.log("Generating PDF for template:", idTemplate);
            let dateUpdated = new Date(template.updated_at);
            const day = String(dateUpdated.getDate()).padStart(2, "0");
            const month = String(dateUpdated.getMonth() + 1).padStart(2, "0"); // Months are 0-based
            const hours = String(dateUpdated.getHours()).padStart(2, "0");
            const minutes = String(dateUpdated.getMinutes()).padStart(2, "0");

            const formattedDate = `${day}_${month}_${hours}_${minutes}`;
            const fileName = `${template.name}_${formattedDate}.pdf`;
            const response = await fetch(pdfUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ids: ids, idTemplate: idTemplate, fileName: fileName, locale: locale, token: token })
            });

            console.log(response.data);
            if (!response.ok) {
                throw new Error("Failed to generate PDF");
            }

            console.log("PDF generated successfully");
            const data = await response.json();
            if (data.pdfUrl) {
                console.log("Opening PDF:", data.pdfUrl);
                window.open(data.pdfUrl, "_blank"); // ✅ Open PDF in a new tab
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
            alert("Error generating PDF. Please try again.");
        } finally {
            setLoadingTemplateId(null); // ✅ Remove loader after PDF is generated
        }
    }

    if (fetchError) return <p>Error: {fetchError}</p>;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }).format(date);
    };

    return (
        <div className="template-container">
            {/* ✅ Full-page loader */}
            {loadingTemplates && (
                <div className="full-page-loader">
                    <div className="loader"></div>
                </div>
            )}
            <div className="templates-title">
                <div>Choisissez le document à générer à partir des modèles suivants:</div>
            </div>
            <div className="template-container-2">
                {templates.map((template) => (
                    <div
                        key={template.template_id}
                        className={`template-card ${loadingTemplateId === template.template_id ? "loading" : ""}`}
                        onClick={() => loadingTemplateId ? null : handleTemplateClick(template)} // Prevent multiple clicks
                    >
                        <span className="template-title">{template.name} - {formatDate(template.updated_at)} </span>

                        {/* ✅ Loader inside the card for better positioning */}
                        {loadingTemplateId === template.template_id && (
                            <div className="loader-overlay">
                                <div className="loader"></div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

TemplateList2.propTypes = {
    apiBaseUrl: PropTypes.string.isRequired,
};

export default TemplateList2;
